import { toast } from "react-toastify";

export const handleDownload = (filePath, folderName) => {
  // Create an anchor element
  const anchor = document.createElement("a");
  // Set the href attribute to the URL of the file to download
  anchor.href = filePath; // Change "/path/to/your/sample_file.ext" to the actual path of your file
  // Set the download attribute to specify the filename
  anchor.target = "_blank";
  anchor.download = folderName; // Change "sample_file.ext" to your desired filename
  // Simulate a click on the anchor element to trigger the download
  anchor.click();
};

export const allowedExtensionsForImage = ["jpg", "jpeg", "png", "webp"];

function validateFileExtensions(allowedExtensions, files) {
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      return false;
    }
  }
  return true;
}

export const validateImage = (event) => {
  const files = event.target.files;
  const isValid = validateFileExtensions(allowedExtensionsForImage, files);
  if (!isValid) {
    toast.error("File is not valid!");
    return false;
  }
  return true;
};

export const findEmptyIndexes = (socialArray) => {
  return socialArray
    ?.map((item, index) => (!item?.url ? index : null))
    .filter((index) => index !== null);
};

export const generatePassword = ({ length = 10 }) => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "!@#$%^&*()_+[]{}<>?,.";

  const all = upper + lower + numbers + special;

  // Ensure at least one character from each category
  const getRandom = (str) => str[Math.floor(Math.random() * str.length)];
  let password = [
    getRandom(upper),
    getRandom(lower),
    getRandom(numbers),
    getRandom(special),
  ];

  // Fill the rest of the password length
  for (let i = 4; i < length; i++) {
    password.push(getRandom(all));
  }

  // Shuffle password so fixed positions aren't predictable
  return password.sort(() => 0.5 - Math.random()).join("");
};

export const statusText = {
  Received_Under_Review: {
    title: "Received/Under Review",
    description: "Your application has been received and is under review.",
  },
  Additional_Action_Required: {
    title: "Additional Action Required",
    description:
      "Check your email or portal—more information is needed to proceed.",
  },
  Interview_Stage: {
    title: "Interview Stage",
    description:
      "Congrats! You’re shortlisted—check your email for interview details.",
  },
  Awarded: {
    title: "Awarded",
    description: "Congrats! You have been selected as a scholarship recipient.",
  },
  Draft: {
    title: "Draft",
    description: "Application is stll incomolete !",
  },
  Not_Selected: {
    title: " Not Selected",
    description:
      "Not selected this time—thank you for applying and please try again.",
  },
};

export const isDate = (value) => {
  return (
    typeof value === "string" &&
    !isNaN(Date.parse(value)) && // Checks if string is parsable
    !isNaN(new Date(value).getTime()) // Valid date object
  );
};

export const getDetailsObject = (bannerType, val) => {
  switch (bannerType) {
    case "home":
      return {
        testimonial: {
          title: val?.testimonialTitle,
          description: val?.testimonialDesc,
        },
        partner: {
          title: val?.partnerTitle,
          description: val?.partnerDesc,
        },
        existence: {
          title: val?.existenceTitle,
          count: val?.existenceCount,
        },
        scholarAward: {
          title: val?.scholarAwardTitle,
          count: val?.scholarAwardCount,
        },
        beneficiary: {
          title: val?.beneficiaryTitle,
          count: val?.beneficiaryCount,
        },
        fundDistribution: {
          title: val?.fundDistributionTitle,
          count: val?.fundDistributionCount,
        },
        videoSection: {
          title: val?.videoSectionTitle,
          link: val?.videoSectionDesc,
        },
      };

    case "apply":
      return {
        eligibility: {
          title: val?.eligibilityTitle,
          description: val?.eligibilityDesc,
          subtitle: val?.eligibilitySubTitle,
          eligibilityImage: val?.eligibilityImage,
        },
        timeline: {
          title: val?.timelineTitle,
          description: val?.timelineDesc,
          image: val?.timelineImage,
        },
        faq: {
          title: val?.faqTitle,
          description: val?.faqDesc,
          image: val?.faqImage,
        },
      };

    case "v'Peters":
      return {
        publication: {
          title: val?.publicationTitle,
          description: val?.publicationDesc,
        },
        inspire: {
          title: val?.inspireTitle,
          description: val?.inspireDesc,
          image: val?.inspireImage,
        },
        impact: {
          title: val?.impactTitle,
          description: val?.impactDesc,
          image: val?.impactImage,
        },
        firstSubSection: {
          title: val?.firstSubSectionTitle,
          count: val?.firstSubSectionCount,
          image: val?.subSectionimage,
        },
        secondSubSection: {
          title: val?.secondSubSectionTitle,
          count: val?.secondSubSectionCount,
        },
        thirdSubSection: {
          title: val?.thirdSubSectionTitle,
          count: val?.thirdSubSectionCount,
        },
      };

    case "updatesAndBlogs":
      return {
        blog: {
          title: val?.blogTitle,
          description: val?.blogDesc,
        },
      };

    case "takeAction":
      return {
        takeAction: {
          image: val?.actionImage,
          sectionImage: val?.sectionImage,
        },
      };

    default:
      return {};
  }
};

export const forceDownload = async (url, filename = "download") => {
  try {
    const response = await fetch(url, { mode: "cors" }); // Must support CORS
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
    alert("Failed to download the file.");
  }
};

export function truncateHtmlByWords(html = "", wordLimit = 125) {
  if (!html) return "-";

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  let wordCount = 0;
  const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT);
  const collected = [];

  while (walker.nextNode()) {
    const nodeText = walker.currentNode.nodeValue;
    const words = nodeText.trim().split(/\s+/).filter(Boolean);
    const remaining = wordLimit - wordCount;

    if (remaining <= 0) break;

    if (words.length <= remaining) {
      collected.push(nodeText);
      wordCount += words.length;
    } else {
      collected.push(words.slice(0, remaining).join(" ") + "...");
      wordCount += remaining;
      break;
    }
  }

  const outputDiv = document.createElement("div");
  outputDiv.textContent = collected.join(" ");
  return outputDiv.innerHTML;
}

export const isEqual = (a, b) => {
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
};

export const taxTypes = [
  { name: "Sales tax", value: "Sales_Tax" },
  { name: "VAT", value: "VAT" },
  { name: "GST", value: "GST" },
];

export const includeTaxOptions = [
  { name: "No (exclusive)", value: "exclusive" },
  { name: "Yes (inclusive)", value: "inclusive" },
];

export const scopeOptions = [
  { name: "All", value: "all" },
  { name: "Plan", value: "plan" },
  { name: "Addon", value: "addon" },
];
